import React from "react";
import { Redirect, Route, Switch } from "react-router";
import ReclamoDetalles from "src/pages/ReclamoDetalles";
import ReclamoSolicitudExito from "src/pages/ReclamoSolicitudExito";
import { ReclamosProcesosProps } from "src/utils";

const ReclamosProcesos: React.FC<ReclamosProcesosProps> = (
  props: ReclamosProcesosProps
) => {
  return (
    <Switch>
      <Route
        path="/reclamos/procesar/enviado"
        component={ReclamoSolicitudExito}
      />

      <Route
        path="/reclamos/procesar/:id"
        component={() => <ReclamoDetalles cargo={props.cargo} />}
      />

      <Route
        exact
        path="/reclamos/procesar"
        component={() => <ReclamoDetalles cargo={props.cargo} />}
      />

      <Redirect to="/" />
    </Switch>
  );
};

export default ReclamosProcesos;
